import isByteLength from 'validator/lib/isByteLength';

const MAX_SQL_TEXT_BYTE_LENGTH = 65_535;

/**
 * Max num of bytes for sql `TEXT` type — use to check whether a string is within that limit
 * (e.g. via {@link isMaxByteLength}).
 */
export function getMaxSqlTextByteLength(): number {
	return MAX_SQL_TEXT_BYTE_LENGTH;
}

export function isMaxByteLength(val: string, maxLength: number): boolean {
	return isByteLength(val, { min: 0, max: maxLength });
}
